import { Type } from 'class-transformer';
import {
  IsArray,
  IsBoolean,
  IsIn,
  IsObject,
  IsOptional,
  IsString,
  IsUUID,
  ValidateNested,
} from 'class-validator';
import type { IngredientListComponent } from '../../allergen-core/types';
import { ALLERGEN_CATEGORY_KINDS, type AllergenCategoryKind } from './ingredient-allergen.dto';

/**
 * RESOLVED: figlio visibile e dichiarato. UNDECLARED: figlio mai dichiarato
 * (fail-closed come un ingrediente diretto non dichiarato). Gli altri valori
 * sono i limiti della composizione annidata.
 */
export const LINKED_INGREDIENT_STATUSES = [
  'RESOLVED',
  'UNDECLARED',
  'TOO_DEEP',
  'TOO_LARGE',
  'CYCLE',
  'OUT_OF_SCOPE',
] as const;
export type LinkedIngredientStatus = (typeof LINKED_INGREDIENT_STATUSES)[number];

export class LinkedIngredientDerivedAllergenDto {
  @IsUUID()
  allergenId!: string;

  @IsOptional()
  @IsString()
  substanceId?: string | null;

  @IsIn(ALLERGEN_CATEGORY_KINDS)
  category!: AllergenCategoryKind;
}

/** Sintesi read-only del figlio mostrata sulla riga linkata del padre. */
export class LinkedIngredientSummaryDto {
  @IsUUID()
  id!: string;

  @IsString()
  name!: string;

  @IsOptional()
  @IsString()
  labelName?: string | null;

  @IsBoolean()
  isGlobal!: boolean;

  @IsIn(LINKED_INGREDIENT_STATUSES)
  status!: LinkedIngredientStatus;

  /** Allergeni dell'intero sottoalbero, con la categoria con cui il padre li eredita. */
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => LinkedIngredientDerivedAllergenDto)
  derivedAllergens!: LinkedIngredientDerivedAllergenDto[];

  /**
   * La riga collegata come la stampa l'elenco ingredienti
   * (`toIngredientListComponents`: sottoalbero espanso, esenzione dalla
   * scomposizione). L'anteprima del padre la inserisce al posto della riga
   * tenendo ordine, percentuale ed esenzione carry-over della riga stessa.
   */
  @IsOptional()
  @IsObject()
  listComponent?: IngredientListComponent;
}
